'use strict'
import * as session from './session';
import $ from 'jquery';
import Mustache from 'mustache';
import utils from '../util';
import pick from 'lodash/pick';
import omit from 'lodash/omit';
import without from 'lodash/without';
import keys from 'lodash/keys';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import assign from 'lodash/assign';
import isArray from 'lodash/isArray';
import intersection from 'lodash/intersection';
import uniq from 'lodash/uniq';
import invert from 'lodash/invert';
import isEmpty from 'lodash/isEmpty';
import serialize from 'form-serialize';
import pullAll from 'lodash/pullAll';
import { openingToNewTab } from '../util/helpers';
import { getProductDataLayerData } from '../product/product-card';
import { addCampaignClasses } from '../product/product-carousel';

/* global mapping, lockedFilterGroups */

let mapping = {};

export default function() {

	const templates = {
		list: $('#template-product-list').html(),
		item: $('#template-product-list-item').html(),
		filters: $('#template-product-list-filters').html(),
		activeFilters: $('#template-product-list-active-filters').html(),
	};

	//productCarousel('.product-carousel');
	productListItems();
	productListFilters();
	readMoreToggle();
	productImpressions();

	/**
	 * Tracks product impressions everywhere
	 */
	function productImpressions() {
		let productImpressions = [];
		let timeout = null;

		document.addEventListener('lazyloaded', function(e) {
			const $productItem = $(e.target).closest('.product-list-item');
			if ($productItem.length) {
				let dataLayerData = getProductDataLayerData($productItem.get(0));

				productImpressions.push(dataLayerData);

				if (timeout) {
					clearTimeout(timeout);
				}

				timeout = setTimeout(() => {
					if (window.GoogleTagManager.isEnabled()) {
						window.GoogleTagManager.productImpressions(productImpressions);
						productImpressions = [];
					}
				}, 5000);
			}
		});
	}

	function productListFilters() {

		$('.static-category-listing').each(function () {

			const $container = $(this);
			const $form = $container.find('form.product-filters');
			//if (!$container.length) return;

			mapping = $form.data('mapping') || window.mapping || {};

			const $grid = $container.find('.product-grid');
			const $activeFilters = $container.find('.active-filters');
			const $toolbar = $container.find('.toolbar-mobile');
			const $pageHeading = $container.find('.o-page__heading');
			const $filters = $container.find('.product-category-additional-filters');

			const submitHandler = debounce(handleFormSubmit, 500);
			const defaultOrder = $form.data('default-order') || 'new';
			const additionalFields = mapAdditionalFields();

			// input names that are used as URL parameters
			const paramFields = ['category', 'sport', 'brands', 'color', 'size','genders',
				'order', 'campaigns', 'night', 'categoryType', 'subcategory', 'day', 'salePercentage', 'chain', 'shops', 'collection'].concat(additionalFields);

			let _shouldReload = false;
			let _lastFilterData = null;
			let _xhr = null;
			let _loadMoreCounter = 0;
			let _productsCount;

			const _totalProductsCount = $activeFilters.data('total-products');
			const urlParams = parseParams(window.location.search.substring(1));
			const _filterPreset = $form.data('preset');
			const _chainCampaigns = typeof _filterPreset !== 'undefined' && _filterPreset ? _filterPreset.chainCampaigns : [];
			const _initialData = prepareData(serialize($form.get(0), { hash: true }), urlParams);

			// Event for updating filter presets, used by package builders
			$form.on('filter-preset-update', function (ev, data) {
				for (let key in data) {
					if (Object.prototype.hasOwnProperty.call(data, key)) {
						_filterPreset[key] = data[key];
					}
				}
				// Trigger custom event after update
				$(this).trigger('filter-preset-update-done', [ _filterPreset ]);
			});

			if ($form.length) {
				if ($form.closest('.search-results').length) {
					updateFilters(_initialData, urlParams).then((res) => {
						_lastFilterData = prepareData(serialize($form.get(0), { hash: true }), urlParams);
						return renderActiveFilters(res.activeFilters || [], res.productsCount);
					});

				}
				else {
					_lastFilterData = _initialData;
					session.init(mapping);
				}

				$form.on('change', 'input, select', (e, system) => {
					const $input = $(e.target);
					submitHandler.cancel();

					if ($('#package-builder').length === 0) {
						//For filter google analytics
						let categoryLabel = $('.filter-select.active').data('name');
						let filterLabel = $input.closest('.filter-toggle').find('.name').text();

						if ($input.attr('name').indexOf('gender') !== -1) {
							categoryLabel = 'Kohderyhmä';
							filterLabel = $input.parent().find('label').text();
						} else if($input.attr('name').indexOf('order') !== -1) {
							categoryLabel = 'Järjestä';
						} else if ($input.attr('value').indexOf('brands') !== -1) {
							categoryLabel = 'Merkki';
						}

						if (!filterLabel || filterLabel === '') {
							filterLabel = $input.val();
						}

						if (window.GoogleTagManager.isEnabled()) {
							window.GoogleTagManager.clickFilter(categoryLabel, filterLabel);
						}
					}

					if ($input.is('.group-filter:not(.hidden-input)')) {
						$input
							.closest('fieldset')
							.children('ul')
							.find('input')
							.prop('checked', $input.is(':checked'));
					} else if ($input.closest('.filter-groups').length) {
						const $parentFilter = $input
							.closest('fieldset')
							.find('.group-filter');
						if (!$input.is(':checked')) {
							$parentFilter.prop('checked', false);
							const $siblings = $input
								.closest('fieldset')
								.children('ul')
								.find('input');
							if (!$siblings.find('input:checked').length) {
								$parentFilter.prop('checked', false);
							}
						} else if ($parentFilter.hasClass('hidden-input')) {
							$parentFilter.prop('checked', true);
						}
					}
					$form.trigger('submit', [system]);
				});

				// filter products
				$form.submit((e, system) => {
					e.preventDefault();
					submitHandler.cancel();
					const data = serialize($form.get(0), {hash: true});
					//console.log(data);
					return submitHandler.call(null, data, false, system);
				});

				// load more button
				$grid.on('click', '.load-more', handleLoadMore);

				// reset single filter value
				$activeFilters.on('click', '.btn-tag', e => unsetActiveFilter($(e.currentTarget)));

				// reset all filters button
				$container.on('click', '.reset-filters', resetFilters);

				$container.on('click', '.show-next-day .lift-cta', e => {
					const $this = $(e.currentTarget);
					const nextDay = $this.data('day');
					if (nextDay) {
						$('.campaigns-filter input[name="day[]"]:checked').prop('checked', false);
						const $input = getInput('day', nextDay);
						$input.prop('checked', true).change();
						$('html, body').animate({
							scrollTop: $('.static-category-listing').offset().top
						}, 700);
					} else {
						$('.campaigns-filter input[name="day[]"]:checked').prop('checked', false).change();
						$('html, body').animate({
							scrollTop: $('.static-category-listing').offset().top
						}, 700);
					}
				});

				initFilters();
			}

			initDataLayer();
			backButtonHack();
			pickColorImages();

			// Add campaign classes to $grid markup
			addCampaignClasses($grid);

			$(window).scroll(throttle(handleScroll, 200));


			function initFilters() {
				// open and close filter tabs
				$form.on('click', '.filter-label', (e) => {
					const $tab = $(e.target).closest('li');
					$tab.toggleClass('selected active').siblings().removeClass('selected active').find('.filter-dropdown').addClass('collapsed');
					toggleFilterTab($tab);
				});

				// close filter tabs also by clicking outside the filters
				$(document).on('click', function(e) {
					const $selectedFilterLabel = $filters.find('.filter-select.selected .filter-label');
					if ($selectedFilterLabel.length && !$(e.target).closest('.filter-select').length && !$(e.target).parents('.product-list-item .thumbnails').length > 0) {
						$selectedFilterLabel.trigger('click');
					}
				});
				// Add accessibility support for keyboard users
				$form.on('keydown', '.filter-label', (e) => {
					const $tab = $(e.target).closest('li');
					if (e.code === 'Space' || e.code === 'Enter') {
						e.preventDefault();
						$tab.toggleClass('selected active').siblings().removeClass('selected active').find('.filter-dropdown').addClass('collapsed');
						toggleFilterTab($tab);
					}
				});


				if ($pageHeading.length) {
					$toolbar.detach().insertAfter($pageHeading).addClass('attached');
				} else {
					$toolbar.addClass('attached');
				}

				$toolbar.add($activeFilters).on('click', '.show-filters', () => {
					$form.addClass('fullheight open');
					$('body').addClass('filters-open');
					setTimeout(() => $('.filter-actions').addClass('visible'), 250);
				});

				$container.on('click', '.show-products', () => {
					$('body').removeClass('filters-open');
					$('.filter-select').removeClass('selected');
					$('.filter-actions').removeClass('visible')
					$('.product-filters').removeClass('open').one(utils.transitionDone(), () => {
						$form.removeClass('fullheight');
					});
				});

				const $productSort = $form.find('#products-sort');
				const $mobileSort = $toolbar.find('#products-sort-mobile');
				const $desktopSort = $container.find('#desktop-products-sort');

				$mobileSort.val($productSort.val())
					.on('change', (e) => {
						const newValue = $(e.target).val();
						$desktopSort.val(newValue);
						$productSort.val(newValue).trigger('change');
					});

				$desktopSort.val($productSort.val())
					.on('change', (e) => {
						const newValue = $(e.target).val();
						$mobileSort.val(newValue);
						$productSort.val(newValue).trigger('change');
					});


				const $campaignFilter = $form.find('.campaigns-selector').clone().insertBefore($toolbar).addClass('mobile is-mobile is-hidden-desktop');
				$campaignFilter.find('input').each((i, el) => $(el).attr('id', $(el).attr('id') + '-mobile'));
				$campaignFilter.find('label').each((i, el) => $(el).attr('for', $(el).attr('for') + '-mobile'));

				$campaignFilter.find('input').change(e => {
					const $target = $(e.currentTarget);
					const $input = $form.find(`.campaigns-filter input[value="${$target.attr('value')}"]`);
					$input.prop('checked', $target.is(':checked')).change();
				});

				preSelectGenderSelection();
			}

			/**
			 * Preselects gender filter selection based on selected
			 * navigation (e.g. naiset, miehet, lapset)
			 */
			function preSelectGenderSelection() {
				const selectedNavigation = JSON.parse(localStorage.getItem('navigationState'))?.navigation;
				const $genderFilters = $('.genders-filter');

				if (!selectedNavigation) {
					return;
				} else if (selectedNavigation === 'women') {
					$genderFilters.find('#genders-naisten').trigger('click');
				} else if (selectedNavigation === 'men') {
					$genderFilters.find('#genders-miesten').trigger('click');
				} else if (selectedNavigation === 'children') {
					$genderFilters.find('#genders-lasten').trigger('click');
					$genderFilters.find('#genders-nuorten').trigger('click');
				}
			}

			/**
       * Handle scroll event, lazyload products
       */
			function handleScroll(e) {
				const $button = $('.load-more');

				if (!isLoading() && $button && $button.length) {
					const buttonOffset = $button.offset().top;
					const scrollTop = $(window).scrollTop() + $(window).height();
					if (scrollTop > buttonOffset && _loadMoreCounter > 0) {
						$button.click();
					}
				}
			}

			/**
       * Return true if ajax is in progress.
       *
       * @return {Boolean}
       */
			function isLoading() {
				return !!_xhr && _xhr.readyState === 1;
			}

			/**
       * Toggle tab visibility on mobile.
       *
       * @param  {jQuery} $tab
       */
			function toggleFilterTab($tab) {
				const $menu = $tab.find('.filter-dropdown');
				const $clone = $menu.clone();

				if ($tab.hasClass('active')) {
					const newHeight = $clone.appendTo($tab)
						.css('height', '')
						.removeClass('collapsed')
						.outerHeight();

					$clone.remove();
					$menu.css('height', newHeight).removeClass('collapsed');

					//$form.find('.filter-select.selected').not($tab).each((i, el) => toggleFilterTab($(el)));
				}
				else {
					$menu.css('height', $menu.outerHeight());
					$menu.css('height');
					$menu.addClass('collapsed');
				}
			}

			/**
       * Hack to revert the procuct list to same position when coming
       * with the back button. This is done by saving the product list markup and vertical scroll position on
       * session storage and setting a hash parameter telling that markup can be
       * loaded from storage.

       */
			function backButtonHack() {
				const markupStorageKey = 'v4_' + location.pathname;
				const yPositionStorageKey = 'v4_yPosition_' + location.pathname;
				if (window.sessionStorage) {
					if (location.hash.indexOf('|_s') > -1) {
						try {
							const markup = sessionStorage.getItem(markupStorageKey);
							const scrollYPosition = sessionStorage.getItem(yPositionStorageKey);
							if (markup) {
								$grid.html(markup);
								sessionStorage.removeItem(markupStorageKey);
								history.replaceState(null, '', location.pathname + location.search); // remove hash
							}
							if (scrollYPosition) {
								window.scrollTo(0, scrollYPosition);
								sessionStorage.removeItem(yPositionStorageKey);
							}
						} catch (e) {
							console.log(e);
						}
					}

					$('.product-grid').on('click', '.product-list-item a', function(e) {
						const markup = $(this).closest('.product-grid').html();
						const scrollPosition = window.pageYOffset;
						try {
							sessionStorage.setItem(markupStorageKey, markup);
							sessionStorage.setItem(yPositionStorageKey, scrollPosition);
						} catch (e) {
							console.log(e);
						}
						history.replaceState(null, '', '#|_s');
					});
				}
			}

			function producGridItemDatalayerClick(e, elem) {
				if ($(elem).closest('.product-grid').length) {
					// Create google ecommerce click event

					if (window.GoogleTagManager.isEnabled()) {
						const newTab = openingToNewTab(e);
						if (!newTab) {
							// Prevent actual click event if not opening to new tab (so that datalayer has the time to receive the event)
							// Opening to new tab is allowed, because tag manager event will not be interrubted
							e.preventDefault();
						} else {
							e.stopPropagation();
						}

						const $productItem = $(elem).closest('.product-list-item');
						const dataLayerData = getProductDataLayerData($productItem.get(0));

						window.GoogleTagManager.clickProduct(dataLayerData, newTab);
					}

					// EOF: create google ecommerce click event
				}
			}

			function initDataLayer() {
				$('.product-grid').on('click', '.product-list-item a', function(e) {
					producGridItemDatalayerClick(e, this);
				});
				$('.product-grid').on('auxclick', '.product-list-item a', function(e) {
					if (e.button && e.button === 1) {
						producGridItemDatalayerClick(e, this);
					} else if (e.button && e.button === 2) {
						// This is opening the context menu
						// Not so simple to detect a click here
					}
				});
			}
			/**
       * @return {Array}
       */
			function mapAdditionalFields() {
				let additionalFields = [];
				if (typeof mapping.additionalField === 'object' && mapping.additionalField) {
					additionalFields = keys(mapping.additionalField);//.map(slug => slug + '[]');
				}
				return additionalFields;
			}

			function buildFilterPath(fields, data) {
				const pathData = pick(data, fields);
				const filterPath = [];
				fields.forEach(function(field) {
					if (pathData[field]) {
						filterPath.push(pathData[field].replace(/,/g, '-'));
					}
				});
				return filterPath.join('-');
			}

			/**
       * Create a URL-encoded query string from parameters object.
       *
       * @param  {Object} params
       * @return {String}
       */
			function getQueryString(params) {
				const urlencoded = decodeURIComponent($.param(params));
				if (urlencoded.length) {
					return '?' + urlencoded;
				}
				return window.location.href.split('?')[0];
			}


			/**
       * Apply filters and load products. Update filters if needed.
       *
       * @param  {Object} data   form data
       * @return {Promise}
       */
			function handleFormSubmit(data, reload, systemEvent) {
				const urlParams = buildUrlParams(data);
				const queryString = getQueryString(urlParams);
				const preparedData = prepareData(data, urlParams);

				_shouldReload = false; // reset reload flag

				history.replaceState({urlParams}, '', queryString);

				renderActiveFilters(data, _productsCount);

				const isUpdateFilters = !reload && shouldUpdateFilters(preparedData);

				const updateFiltersPromise = isUpdateFilters
					? updateFilters(preparedData, urlParams, !systemEvent)
					: $.Deferred().resolve();

				return $.when(filterProducts(preparedData, urlParams), updateFiltersPromise)
					.then((producsCount, filters) => {
						if (isUpdateFilters && !data.inpackagebuilder) {
							const filteredData = filterInactiveParams(data);
							if (_shouldReload) {
								return handleFormSubmit(filteredData, true);
							}
						}
						renderActiveFilters(data, _productsCount);
						updateProductsCount(_productsCount);
						addCampaignClasses($grid);
						pickColorImages(data);
						_lastFilterData = preparedData;
					});
			}

			/**
       * Filter form data to include only values that are currently active in the form.
       * Set a flag to reload products if needed.
       *
       * @param  {Object} data
       * @return {Object}
       */
			function filterInactiveParams(data) {
				const copy = $.extend({}, data);
				$.each(omit(data, 'order', 'pageId', 'chain', 'vm'), function(key, values) {
					const paramsArray = normalizeArray(values).filter(val => {
						if (!getInput(key, val)) {
							// filter value isn't available anymore due to updated filters
							_shouldReload = true;
							return false
						}
						return true;
					});
					if (!paramsArray.length) {
						delete copy[key];
					} else {
						copy[key] = paramsArray;
					}
				});
				return copy;
			}

			/**
       * @param  {Object} data
       * @return {Promise}
       */
			function filterProducts(data) {
				if (_xhr) _xhr.abort();
				const $loading = $grid.add($form.find('.cta'));
				const ajaxUrl = $form.data('ajax');

				$loading.addClass('loading');

				_xhr = $.getJSON(ajaxUrl, data);

				return _xhr.then(res => {
					if (typeof res === 'object' && res) {
						const markup = Mustache.render(templates.list, res, {item: templates.item});
						$grid.html(markup);
						addCampaignClasses($grid);
						_productsCount = res.productsCount;

						updateProductsCount(_productsCount);

						if (res.pageTitle) {
							updateTitle(res.pageTitle);
						}
						if (res.pageTitleShort) {
							updateTitle(res.pageTitleShort, true);
						}

						toggleNextDayButton(res);
						toggleSelectedDay(res.selectedDay);
						checkNightBadge();

						$grid.trigger('filterProducts', [ res ]);
						_loadMoreCounter = 0;
						return _productsCount;
					}
					return $.Deferred().reject() ;
				})
					.always(() => $loading.removeClass('loading'));
			}

			function parseParams(str) {
				return str.split('&').reduce(function (params, param) {
					var paramSplit = param.split('=').map(function (value) {
						return decodeURIComponent(value.replace('+', ' '));
					});
					params[paramSplit[0]] = paramSplit[1];
					return params;
				}, {});
			}

			function toggleNextDayButton(res) {

				if (res.nextDay) {
					const $nextDayClone = $('.product-list > .show-next-day').clone(true);
					$nextDayClone.removeClass('hidden');
					$nextDayClone.find('.lift-cta').data('day', res.nextDay);
					$nextDayClone.find('.lift-cta h4').html('Katso seuraavan päivän tarjoukset');
					$nextDayClone.appendTo('.vm-campaign .product-grid .products'); //Siirrä "Näytä seuraavien päivien tarjotukset"-nappi tuotelistaan

				} else if(res.showAllDiscounts) {
					const $nextDayClone = $('.product-list > .show-next-day').clone(true);
					$nextDayClone.removeClass('hidden');
					$nextDayClone.find('.lift-cta').data('day', '');
					$nextDayClone.find('.lift-cta h4').html('Katso kaikki viheltäen menee -tarjoukset');
					$nextDayClone.appendTo('.vm-campaign .product-grid .products'); //Siirrä "Näytä seuraavien päivien tarjotukset"-nappi tuotelistaan
				} else {
					$('.products > .show-next-day').remove();
				}
			}

			function checkNightBadge() {
				if (!$('.night-badge:visible').length) {
					$('.product-grid').addClass('no-night-badges');
				}
			}

			function toggleSelectedDay(selectedDayText) {
				if (selectedDayText) {
					$container.find('.selected-day').removeClass('invisible').find('h2').html(selectedDayText);
				} else {
					$container.find('.selected-day').addClass('invisible');
				}
			}

			/**
       * Update available filters q
       * @param  {Object} data
       * @param  {Object} urlParams
       * @return {Promise}
       */
			function updateFilters(data, urlParams, setPreference) {
				const copy = $.extend({}, data);
				//const copy = pick(data, 'pageId', 'genders[]', 'campaigns[]', 'vm', 'packagebuildergroup', 'category[]', 'subcategory[]', 'categoryType[]');

				if ($form.hasClass('dynamic')) {
					copy.preset = _filterPreset;
				}

				copy.params = $.extend({}, urlParams);

				copy.lockedFilters = window.lockedFilterGroups || [];

				if (setPreference) {
					session.preferences.set({ genders: copy['genders[]'] || [] });
					session.updateNavigationLinks();
				}

				$form.addClass('loading');
				return $.getJSON($filters.data('ajax'), copy)
					.then((res) => {
						if (res && res.filters) {
							const selectedTab = $('.filter-select.selected').data('filter');
							const activeTabs = $.map($('.filter-select.active'), val => $(val).data('filter'));
							if (selectedTab) {
								res.filters.forEach(filter => {
									if (filter.input === selectedTab) {
										filter.open = true;
									}
									if (activeTabs.indexOf(filter.input) > -1) {
										filter.isActive = true;
									}
								});
							}
							if (res.mapping) {

								const preserved = pick(mapping, ['day', 'campaignClass']);
								mapping = res.mapping;
								assign(mapping, preserved);
							}
							const markup = Mustache.render(templates.filters, $.extend(res, {
								productsCount: _productsCount,
								extraFilters: res.extraFilters || []//$form.data('extra-filters')
							}));
							$filters.html(markup);
						}
						return res;
					})
					.always(() => $form.removeClass('loading'));
			}

			/**
       * @param  {Object} data
       * @return {Boolean}
       */
			function shouldUpdateFilters(data) {
				if ($form.data('should-update')) {
					$form.data('should-update', false);
					return true;
				}
				if (!_lastFilterData) {
					return true;
				}
				const updateOnChange = ['genders', 'campaigns', 'categoryType', 'category'];
				const prevData = _lastFilterData || {};
				const hash = pick(data, updateOnChange);
				const prevHash = pick(prevData, updateOnChange);
				const shouldUpdate = updateOnChange.filter(key => {
					const prev = prevHash[key] || [];
					const cur = hash[key] || [];
					if (prev.length !== cur.length) {
						return true;
					}
					return intersection(cur, prev).length !== prev.length;
				});

				return !!shouldUpdate.length;
			}

			/**
       * Load next page of products.
       * @param  {Event} e
       */
			function handleLoadMore(e) {
				if (_xhr) _xhr.abort();

				e.preventDefault();
				const $button = $(e.target);
				const page = $button.attr('data-nextpage');
				const $loading = $grid.find('.next-page');

				const data = serialize($form.get(0), { hash: true });
				data.page = page;

				history.replaceState('', '', location.pathname + location.search);

				$loading.addClass('loading');

				_xhr = $.getJSON($form.data('ajax'), prepareData(data, buildUrlParams(data)));

				return _xhr.done((res) => {
					if (res.nextPage) {
						if (res.nextPage.number) {
							$button.attr('data-nextpage', res.nextPage.number);
						}
						if (res.nextPage.href) {
							$button.attr('href', res.nextPage.href);
						}
					} else {
						$button.remove();
					}

					toggleSelectedDay(res.selectedDay);

					if (res.products && res.products.length) {

						const markup = Mustache.render(
							'{{#products}}{{>item}}{{/products}}',
							{products: res.products},
							{item: templates.item}
						);

						$grid.find('.products').append(markup);
						addCampaignClasses($grid);
						pickColorImages(data);

						_loadMoreCounter++;
						if (_loadMoreCounter > 3) {
							_loadMoreCounter = 0;
						}

						toggleNextDayButton(res);
					}
				})
					.always(() => $loading.removeClass('loading'));
			}

			function getCategoriesByType(type) {
				const $input = getInput('categoryType', type);
				if (!$input) return [];
				return $input.closest('fieldset')
					.find('input[name="category[]"]')
					.map((i, el) => $(el).val())
					.get();
			}

			/**
       * Extract url parameters from form data.
       *
       * @param  {Object} data
       * @return {Object}
       */
			function buildUrlParams(data) {
				let params = {};

				if (data.categoryType && data.category) {
					data.categoryType.forEach(type => {
						const categories = getCategoriesByType(type);
						pullAll(data.category, categories);
					});
				}

				$.each(pick(data, paramFields), (key, value) => {
					if (key === 'order' && value === defaultOrder) {
						return;
					}
					if (Array.isArray(value)) {
						value = value.join(',');
					}
					if (value) {
						params[key] = value;
					}
				});

				const pathParams = ['genders', 'color', 'brands'];
				const id = buildFilterPath(pathParams, params);

				pathParams.forEach(param => delete params[param]);

				if (id) {
					params = $.extend({id}, params);
				}
				return params;
			}

			/**
       * Select the correct preview images in product listing based on selected
       * color filter.
       *
       * @param  {Object} data   form data
       */
			function pickColorImages(data = serialize($form.get(0), { hash: true })) {
				const color = data['color'];
				const selectColor = color => {
					return setTimeout(() => $grid.find(`.img[data-color*="${color}"]`).click(), 10);
				}

				if (color) {
					if (isArray(color)) {
						color.forEach(selectColor);
					} else {
						selectColor(color);
					}
				}
			}

			/**
       * @param  {Number} count
       */
			function updateProductsCount(count) {
				return $container.find('.products-count').html(count);
			}

			function updateTitle(title, short) {
				//$('title').html(title + ' netistä | Intersport');

				if (typeof short === 'undefined' || !short) {
					$container.find('.breadcrumb-title').html(title);
					$form.find('.filter-title').html(title);
				} else {
					$form.find('.filter-title-short').html(title);
				}
			}

			/**
       * Reset all active filters.
       */
			function resetFilters() {
				const $buttons = $activeFilters.find('.btn-tag');
				const buttonsCount = $buttons.length;
				$buttons.each((i, el) => {
					const submit = i === buttonsCount - 1 || $(el).data('filter') === 'categoryType';
					unsetActiveFilter($(el), submit);
				});
				$('.filter-select').removeClass('selected');
			}

			/**
       * Prepare form data for ajax request. Map parameters to normalized
       * values.
       *
       * @param  {Oject} data
       * @return {Object}
       */
			function prepareData(data, urlParams) {
				let copy = prepareAdditionalFields(data);

				// filter out empty values. for example, <select> default values in package builder
				for (let key in copy) {
					if (!copy[key]) delete copy[key];
				}

				if (copy['priorityProducts'] && data.order && data.order !== ($form.data('default-order') || 'new')) {
					delete copy['priorityProducts'];
				}

				if ($form.hasClass('dynamic')) {
					assign(copy, _filterPreset);
				}

				if (copy['color']) {
					copy.normalizedColor = copy['color'];
				}
				if (copy['salePercentage']) {
					copy = $.extend(copy, parseSalePercentage(copy['salePercentage']));
					delete copy['salePercentage'];
				}

				if (urlParams && $form.hasClass('dynamic')) {
					copy.params = $.extend({}, urlParams);
				}

				if (copy.sizeType) {
					copy.categoryType = copy.sizeType;
					delete copy.sizeType;
				}

				if (!copy.day && $('.campaigns-filter').length) {
					copy.day = uniq($('.campaigns-filter input').map(function() {
						return $(this).attr('value');
					}).get());
				}

				$.each(mapping || {}, (key, map) => {
					//const fieldName = key + '[]';
					if (copy[key]) {
						const values = normalizeArray(copy[key]);
						if (values.length) {
							copy[key] = $.map(values, (name) => {
								return map[name] || name;
							});
						}
					}
				});
				if (copy['day']) {
					copy['campaigns'] = copy['day'];
					delete copy['day'];
				}
				if (copy.chain === 1 && copy.campaigns) {
					copy.campaigns = copy.campaigns.filter(campaignId => _chainCampaigns.includes(campaignId));
					if (!copy.campaigns.length) {
						copy.noProducts = true;
					}
				}
				//copy.userFilters = getUserFilterKeys(copy);
				return copy;
			}

			/**
       * Group additional field data.
       *
       * @param  {Object} data
       * @return {Object}
       */
			function prepareAdditionalFields(data) {
				let copy = $.extend({}, data); // create a deep copy, don't wanna mutate the original data
				const fieldData = pick(copy, additionalFields);

				copy = omit(copy, additionalFields);

				$.each(fieldData, (key, value) => {
					if (value) {
						const newKey = mapping.additionalField[key.replace('[]', '')];
						fieldData[newKey] = $.isArray(value) ? value : [value];
					}
					delete fieldData[key];
				});

				if (!isEmpty(fieldData)) {
					assign(copy, {additional_fields: fieldData});
				}
				return copy;
			}

			function parseSalePercentage(values) {
				const parsed = normalizeArray(values).map(function(value) {
					const val = value.split('-');
					return {
						min: parseInt(val[0]) || '',
						max: parseInt(val[1]) || ''
					};
				});
				const result = {};
				parsed.forEach(function(val, i) {
					result[`salePercentage[${i}][min]`] = val.min;
					result[`salePercentage[${i}][max]`] = val.max;
				})
				return result;
			}

			/**
       * @param  {mixed} value
       * @return {Array}
       */
			function normalizeArray(value) {
				return $.isArray(value) ? value : [value].filter(Boolean);
			}

			/**
       * @param  {jQuery}  $el
       * @param  {Boolean} triggerChange
       * @return {jQuery}
       */
			function unsetActiveFilter($el, triggerChange = true) {
				const $input = getInput($el.data('filter').replace('[]', ''), $el.data('value'));

				if ($input.is('select')) {
					$input.val('');
				} else if ($input.length) {
					$input.prop('checked', false);
				}

				if (triggerChange) {
					$input.change();
				}

				$el.closest('li').remove();
				return $input;
			}

			/**
       * Render currently selected filters.
       *
       * @param  {Object} data
       * @param  {Number} productsCount
       * @return {jQuery}
       */
			function renderActiveFilters(data, productsCount) {
				const filters = Array.isArray(data) ? data : getActiveFilters(data);
				const params = { filters, totalProductsCount: _totalProductsCount };
				const filterMap = {};

				// mobile
				$form.find('.active-options').html('');

				if (filters.length) {
					filters.forEach(filter => {
						filterMap[filter.param] = filterMap[filter.param] || [];
						filterMap[filter.param].push(filter.name.trim());
					});

					// active filters for mobile layout
					$.each(filterMap, (key, val) => {
						$form.find(`[name="${key}"], [name="${key}[]"]`)
							.closest('.filter-select')
							.find('.active-options')
							.html(': ' + val.join(', '));
					});
				}


				if (typeof productsCount !== 'undefined') {
					params.productsCount = productsCount;
				} else {
					const productCountElement = document.querySelector('.active-filters .products-count');
					params.productsCount = _totalProductsCount
					if (productCountElement) {
						const currentCount = parseInt(productCountElement.textContent);
						if (currentCount > 0) {
							params.productsCount = currentCount;
						}
					}
				}

				params.activeFiltersCount = filters.length;

				const markup = Mustache.render(templates.activeFilters, params);
				return $activeFilters.html(markup);
			}

			/**
       * @param  {Object} data
       * @return {Array}
       */
			function getActiveFilters(data) {
				const activeFilters = [];
				const fieldMask = without(paramFields, 'order', 'vm');
				$.each(pick(data, fieldMask), (key, value) => {
					if ($.isArray(value)) {
						const values = value.map(val => {
							if (getInput(key, val)) {
								return {
									value: val,
									param: key,
									name: getInputLabel(key, val, true)
								};
							}
						});
						[].push.apply(activeFilters, values.filter(Boolean));
					}
					else if (getInput(key, value)) {
						activeFilters.push({
							value,
							param: key,
							name: getInputLabel(key, value, true)
						});
					}
				});
				return activeFilters;
			}

			/**
       * Get input element by name and value.
       * @param  {String} name
       * @param  {String} value
       * @return {jQuery}
       */
			function getInput(name, value) {
				let $input = $container.find(`
          input[name="${name}[]"][value="${value}"],
          select[name="${name}"],
          input[type="checkbox"][name="${name}"]:not(.campaign-day)
        `);
				return $input.length ? $input : null;
			}


			/**
       * @param  {String} name
       * @param  {String} value
       * @return {String}
       */
			function getInputLabel(name, value, firstInput = false) {
				let $input = getInput(name, value);
				if ($input && $input.is('select')) {
					return $input.find(':selected').text();
				} else if ($input) {
					if (firstInput) {
						$input = $input.first();
					}
					let $label = $input.next('label').first();
					if (!$label.length) {
						$label = $input.closest('label');
					}
					const label = $label.attr('title') || $label.data('original-title') || $label.text();
					return '' + label;
				}
			}


		}); // end $('.static-category').each
	}

	/**
   * Read more toggle (shows only first paragraph on mobile)
   */
	function readMoreToggle() {
		const $readMoreElem = $('.o-category-listing .js-insert-read-more, .static-category-lander .category-description .content, .static-category .category-description .content');

		$readMoreElem.each(function() {
			var $this = $(this),
				$children = $this.children('p, ul, ol, h3, h4');

			if ($children.text().length) {
				if (!$this.find('.js-read-more-toggle-content').length && $children.length > 1) {
					$this.addClass('m-read-more-toggle');

					$children.not($children.first()).wrapAll($('<div>', { class: 'js-read-more-toggle-content' }).hide());

					$('<button>', { class: 'js-read-more-toggle-button a-link pb-1', type: 'button' })
						.append($('<span>', { class: 'm-read-more-toggle__button-closed', html: 'Näytä lisää' }))
						.append($('<span>', { class: 'm-read-more-toggle__button-open', html: 'Näytä vähemmän' }))
						.appendTo($this);
				}
			}
		});

		$(document).on('click', '.js-read-more-toggle-button', function() {
			var $parent = $(this).parent();

			$parent.toggleClass('is-open').find('.js-read-more-toggle-content').stop(true).slideToggle(200, function() {
				if (!$parent.hasClass('is-open')) {
					var pos = $parent.offset().top - $('.header-content-mobile.sticky').outerHeight();

					if ($(window).scrollTop() > pos) {
						setTimeout(function() {
							$('html, body').stop(true).animate({
								scrollTop: pos
							}, 300);
						}, 50);
					}
				}
			});
		});
	}
}

export function productListItems($container) {
	($container || $('.product-list')).on('mouseenter', '.product-list-item', function() {
		const $product = $(this);

		// lazyload small thumbnails
		$product.find('.thumbnails .img').each(function(){
			const style = $(this).data('style');
			$(this).attr('style', style);
		});

		if( $product.find('.thumbnails > .img').length > 2 ){
			// let itemsToScrollInThumbnails = Math.max( Math.floor( ( $('.thumbnails').width() / 240 ) ), 1 );
			$product.find('.thumbnails').slick({
				dots: false,
				infinite: true,
				speed: 300,
				centerMode: true,
				variableWidth: true,
				slidesToScroll: 1,
				draggable: false,
				focusOnSelect: true,
				arrows: false
			});
		}
	});

	// change thumbnail image
	$('.product-list').on('click.thumbnail', '.img', function(){
		var showImage = $(this).data('showthumbnail');
		var $listItem = $(this).parentsUntil('.product-list-item');

		$listItem.find('.image').removeClass('visible');

		// lazyload thumbnail
		var style = $listItem.find('.'+showImage).data('style');
		$listItem.find('.'+showImage).addClass('visible').attr('style', style );

		// Update links when user changes colors
		const $itemLinks = $listItem.find('a');
		const colorCode = $(this).data('colorCode');

		if (!$itemLinks.data('href')) {
			$itemLinks.data('href', $itemLinks.attr('href'));
		}

		$itemLinks.prop('href', $itemLinks.data('href').split('?')[0] + '?color=' + colorCode.toLowerCase());
	});

	$('.thumbnails button').click(function(e){
		e.stopPropagation();
	});

	// Alternmative carousel (showMore)
	if( window.location.hash.indexOf('showMore') > -1 ){
		$('.product-list.showMore').removeClass('showMore');
	}
	$('.product-list-item.showMore').on('click', function(){
		window.location.hash = 'showMore'
		$(this).closest('.product-list.showMore').removeClass('showMore');
	});
}

export function forceGenderSelect(mapping) {
	if (!mapping && !mapping.genders) return false;
	const $genderFilter = $('.genders-filter');
	const genderPreference = session.preferences.get().genders || [];
	const genderMapping = invert(mapping.genders);
	const availableGenders = $.map($('.genders-filter input'), item => $(item).val());

	const mappedGenders = genderPreference.map(gender => genderMapping[gender] || gender);

	const forceSelect = !!genderPreference.length
    && $genderFilter.length
    && !getSelectedGenders($genderFilter).length
    && mappedGenders.length;

	if (forceSelect) {
		genderFallback(mappedGenders, availableGenders).forEach((gender, i) => {
			const $input = $genderFilter.find(`input[value="${gender}"]`);
			$input.prop('checked', true);
			setTimeout(() => $input.trigger('change', [true]), 10);
		});
	}
	return forceSelect;
}

function genderFallback(genders, availableGenders) {
	const kids = ['tyttojen', 'poikien'];
	let newGenders = genders;
	if (intersection(availableGenders, genders).length === 0) {
		// preference not available
		if (intersection(genders, kids).length > 0 && availableGenders.indexOf('nuorten')) {
			newGenders.push('nuorten');
		} else if (genders.indexOf('nuorten') > -1) {
			newGenders = uniq(newGenders.concat(kids));
		}
	}
	const fallback = newGenders.filter(gender => availableGenders.indexOf(gender) > -1);
	if (fallback.length === availableGenders.length) {
		return [];
	}
	return fallback;
}

/**
 * @return {Array} currently selected genders
 */
function getSelectedGenders($select) {
	if ($select.length) {
		return $.map($select.find('input:checked'), (input) => $(input).val());
	}
	return [];
}

